import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const fetchTestCaseSearch = async ({ moduleId, searchKeyword }) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=searchTCSearch&companyid=${user.companyid}&modid=${moduleId}&key=${searchKeyword || ''}`,
  );

  return response.data;
};

const useTestCaseSearchQuery = (moduleId, searchKeyword, options = {}) => {
  return useQuery({
    queryKey: ["testCaseSearch", moduleId, searchKeyword],
    queryFn: () => fetchTestCaseSearch({ moduleId, searchKeyword }),
    enabled: moduleId !== "" && moduleId !== null,
    ...options,
  });
};

export default useTestCaseSearchQuery; 